import { getDocumentTitle } from '@/helpers/printing';
import { ReactNode, useMemo, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import CardHeader from './CardHeader';
import LoadingIndicator from './LoadingIndicator';
import NoDataCard from './NoDataCard';

interface IProps {
  label: string;
  noData: boolean;
  loading: boolean;
  allowPrint?: boolean;
  onDownload?: () => void;
  children?: ReactNode;
  headerTooltipValue?: ReactNode;
}

const GraphCard = ({ loading, label, onDownload, allowPrint, noData, children, headerTooltipValue }: IProps) => {
  const printContainerRef = useRef<HTMLDivElement>(null);

  const showNoDataCard = useMemo<boolean>(() => !loading && noData, [noData, loading]);
  const headerDisabled = useMemo<boolean>(() => !!(loading || noData), [loading, noData]);

  const onPrint = useReactToPrint({
    documentTitle: getDocumentTitle(label),
    content: () => printContainerRef.current,
  });

  return (
    <div className='flex flex-col h-full w-full print:p-8' ref={printContainerRef}>
      <CardHeader
        onDownload={onDownload}
        onPrint={allowPrint ? onPrint : undefined}
        label={label}
        disabled={headerDisabled}
        tooltipValue={headerTooltipValue}
      />
      {loading ? <LoadingIndicator /> : showNoDataCard ? <NoDataCard /> : children}
    </div>
  );
};

export default GraphCard;
